import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { inductryMaster } from '../Models/InductryMasterModel'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';

@Injectable()
export class InductryMasterServices {
  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.apiURL = baseUrl + 'api/InductryMaster/';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/InductryMaster';
    }
  }

  GetInductryMaster(TokenKey: string): Observable<inductryMaster[]> {
    let fullAPIPath = this.apiURL + '/GetInductryMaster';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.get<inductryMaster[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  

  private extractData(res: Response) {
    let body = res.json();
    //console.log("extractData " + body);
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
